import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
/* import View from './ViewSearch' */
import Xligo from '../Classes/Connection'

const SearchResultsItem = props =>
    <div className={`search-results__item ${props.className}`}>
        <div data-page={props.dataPage} data-id={props.dataId} className="search-results__text" dangerouslySetInnerHTML={{ __html: props.children }} />
        {props.dataPage && <div className="search-results__footer">Pagina {props.dataPage}</div> }
    </div>

SearchResultsItem.propTypes = {
    className: PropTypes.string,
    dataPage: PropTypes.number,
    dataId: PropTypes.string,
}

SearchResultsItem.defaultProps = {
    className: '',
}

const SearchResults = props =>
    <div className={`search-results ${props.className} ${props.noResults ? 'search-results--disabled' : '' }`}>
        <div className="search-results__scroll-container">
            <div className="search-results__items">
                {
                    React.Children.map(props.children, (child, index) => {
                        return React.cloneElement(child, {
                        key: index,
                        })
                    })
                }
            </div>
        </div>
    </div>

SearchResults.propTypes = {
    className: PropTypes.string,
    noResults: PropTypes.bool,
}

SearchResults.defaultProps = {
    className: '',
    noResults: false,
}

class Search extends React.Component
{
    constructor(props)
    {
        super(props)
        this.state = {
            before: [],
            content: null,
            searchDone: false,
            hasResults: false,
            isSearching: false,
            preload: true,
            preview: false,
            word: "",
            page: 0,
            stringLoad: "Carica più risultati",
            type: this.props.type === 'x' ? 'libro' : this.props.type,
            fromPage: this.props.dataPage.fromPage,
            toPage: this.props.dataPage.toPage
        }
    }

    __extraUrlField = () => {
        let url = '';
        if( this.state.fromPage ) {
            url = `${url}&fromPage=${this.state.fromPage}`
        }
        if( this.state.fromPage && this.state.toPage ){
            url = `${url}&toPage=${this.state.toPage}`
        }

        return url
    }

    __handleChange = async (e) => {
        let word = e.target.value
        let page = 0
        // edit
        this.setState({word: word})
        // end
        this.setState({ isSearching: true })
        if ( word.length >= 3 ) {
            /* this.setState({
                content: word,
                preview: true
            }) */
            this.setState({ isSearching: true })
            await Xligo.get(`${this.state.type}/${this.props.bookId}/pagine/_search?query=${word}&size=50&page=${page}&sort=pagina,asc${this.__extraUrlField()}`)
            .then(response => response.json())
            .then(data => {
                if(data.length > 0){
                    this.setState({ content: data, hasResults: true, searchDone: true, page: page})
                } else {
                    this.setState({ hasResults: false, searchDone: true, page:page})
                }
                this.setState({ isSearching: false })
            })
        } else {
            this.setState({ hasResults: false, searchDone: false, isSearching: false })
        }
    }

    __loadMore = async(e) => {
        let word = this.state.word
        let page = this.state.page + 1
        this.setState({ isSearching: true })
        await Xligo.get(`${this.state.type}/${this.props.bookId}/pagine/_search?query=${word}&size=50&page=${page}&sort=pagina,asc`)
        .then(response => response.json())
        .then(data => {
            console.log(page)
            if(data.length > 0){
                const args = [...this.state.content]
                data.forEach(item => {
                    args.push(item)
                })
                this.setState({ content: args, hasResults: true, searchDone: true, page: page})
            } else {
                this.setState({stringLoad: "nessun altro risultato", hasResults: true, searchDone: true, page: page})
            }
            
            this.setState({ isSearching: false })
        })
    }

    componentDidMount(){
        this.searchInput.focus()
    }

    render = () => {
        return (
            <div className={`search-form ${this.props.className}`}>
                <label className="search-input">
                    <FontAwesomeIcon className="search-input__icon" icon={this.props.icon} />
                    <input type="text" onChange={this.__handleChange} name="search" className="search-input__field" ref={(input) => { this.searchInput = input; }} placeholder={this.props.placeholder} autoFocus={true} autoComplete="off" />
                    <FontAwesomeIcon className="search-input__icon search-input__icon--close" icon={faTimesCircle} onClick={this.props.display} />
                </label>

                {this.props.display &&
                    <Fragment>
                        { this.props.isSearching
                            ?   <SearchResults>
                                    <SearchResultsItem>Ricerca in corso...</SearchResultsItem>
                                </SearchResults>
                            :   <Fragment>
                                    {this.state.searchDone &&
                                        <Fragment>
                                            {this.state.hasResults
                                                ?   <SearchResults>
                                                        { this.state.content.map((v, i) => {
                                                            return (<SearchResultsItem key={i} dataPage={v.pagina} dataId={v.pagina.toString(16)}>{ v.highlights[0] }</SearchResultsItem>)
                                                        })}
                                                        <div onClick={this.__loadMore} className={"loadmore"}>
                                                            <p>{this.state.stringLoad}</p>
                                                        </div>
                                                    </SearchResults>
                                                : <SearchResults noResults={true}>
                                                    <SearchResultsItem>Nessun risultato trovato</SearchResultsItem>
                                                </SearchResults>
                                            }
                                        </Fragment>
                                    }
                                </Fragment>
                        }
                    </Fragment>
                }
            </div>
        )
    }
}

Search.propTypes = {
    bookId: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.any,
    onClick: PropTypes.func,
    placeholder: PropTypes.string,
}

Search.defaultProps = {
    className: '',
    placeholder: '',
}

export default Search
